var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M77.686,45.108L61.63,29.051c-0.375-0.375-0.884-0.586-1.414-0.586h-5.368c-1.007,0-1.84,0.744-1.979,1.712 c-0.465,0.417-2.23,1.106-4.868,1.106c-2.638,0-4.403-0.689-4.868-1.106c-0.14-0.968-0.973-1.712-1.979-1.712h-5.368 c-0.53,0-1.039,0.211-1.414,0.586L18.314,45.108c-0.781,0.781-0.781,2.047,0,2.828l5.991,5.991c0.781,0.781,2.048,0.781,2.828,0 l8.583-8.583v20.19c0,1.104,0.896,2,2,2h20.568c1.104,0,2-0.896,2-2v-20.19l8.583,8.583c0.75,0.75,2.078,0.75,2.828,0l5.99-5.991 C78.467,47.155,78.467,45.889,77.686,45.108z M70.281,49.685L59.698,39.102c-0.573-0.573-1.432-0.744-2.18-0.434 c-0.747,0.31-1.234,1.039-1.234,1.848v23.018H39.716V40.516c0-0.809-0.487-1.538-1.234-1.848c-0.749-0.311-1.608-0.139-2.18,0.434 L25.719,49.685l-3.162-3.163l14.057-14.057h3.206c1.423,1.924,4.898,2.818,8.181,2.818s6.758-0.895,8.181-2.818h3.207 l14.056,14.057L70.281,49.685z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirt);
export default __webpack_public_path__ + "static/media/shirt.1310cd8d64bd8ee529ec28ab700330d0.svg";
export { ForwardRef as ReactComponent };